<template>
  <div>
    <div>
      <el-tabs>
        <!-- //文件上传-->
        <el-row name="Versioning">
          <el-button size="mini" @click="addNewV" type="primary"
            >新增</el-button
          >
           <el-table
            :data="users"
            style="width: 100%; margin-top: 20px"
            height="500"
            :header-cell-style="{
              background: '#F2F5FF',
              color: '#333',
              'text-align': 'center',
            }"
            border
          >
            <el-table-column label="序号" width="50px" align="center">
              <template slot-scope="scope">
                {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="Version"
              label="版本号"
              width="100"
              sortable
            />
            <el-table-column prop="Url" label="文件地址" width="400" />
            <el-table-column label="类型" width="60">
              <template slot-scope="scope">
                {{ scope.row.OrderSort == 1 ? "安卓" : "IOS" }}
              </template>
            </el-table-column>
            <el-table-column prop="Content" label="更新内容" />
            <el-table-column
              prop="CreateTime"
              label="创建时间"
              width="170"
              sortable
            />
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdits(scope.row)"
                  type="primary"
                  >更新</el-button
                >
                <el-button
                  size="mini"
                  @click="handleDelect(scope.row)"
                  type="danger"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="PageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="text-align: center;padding:20px; 0 0 0"
          >
          </el-pagination>
        </el-row>
      </el-tabs>

      <!-- 添加 -->
      <el-dialog
        title="添加"
        :visible.sync="dialogToAdd"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-form
          :model="itemForm"
          :rules="itemFormRusle"
          label-width="100px"
          ref="itemForm"
        >
          <el-form-item
            label="文件地址"
            prop="Url"
            v-if="itemForm.OrderSort == '1'"
          >
            <el-upload
              style="width: 400px"
              action="http://importmgdapi.yrtsedu.cn/api/Img/UploadFile"
              :show-file-list="false"
              :on-success="handleAvatarSuccessAudio"
              :before-upload="beforeAudioUpload"
              :on-progress="audioProgress"
            >
              <el-input
                style="width: 400px"
                v-model="itemForm.Url"
                v-bind:disabled="true"
                clearable
                type="textarea"
              ></el-input>
            </el-upload>
            <el-progress
              :percentage="audioPlan"
              style="width: 300px"
              v-if="audioPlan"
            ></el-progress>
          </el-form-item>
          <el-form-item
            label="文件地址"
            prop="Url"
            v-if="itemForm.OrderSort == '2'"
          >
            <el-input
              style="width: 400px"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入内容"
              v-model="itemForm.Url"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="版本号" prop="Version">
            <el-input
              style="width: 400px"
              v-model="itemForm.Version"
            ></el-input>
          </el-form-item>

          <el-form-item label="类型" prop="OrderSort">
            <el-select
              v-model="itemForm.OrderSort"
              clearable
              placeholder="请选择"
            >
              <el-option :key="1" :label="'安卓'" :value="'1'" />
              <el-option :key="2" :label="'IOS'" :value="'2'" />
            </el-select>
          </el-form-item>
          <el-form-item label="更新内容" prop="Content">
            <el-input
              style="width: 400px"
              type="textarea"
              :rows="4"
              v-model="itemForm.Content"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="dialogToAdd = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="addSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog
        title="添加"
        :visible.sync="dialogToEdit"
        width="50%"
        :close-on-click-modal="false"
        @close="Close"
      >
        <el-form :model="itemFormEdit" label-width="100px" ref="itemFormEdit">
          <el-form-item label="文件地址" prop="Url">
            <el-upload
              style="width: 400px"
              action="http://importmgdapi.yrtsedu.cn/api/Img/UploadFile"
              :show-file-list="false"
              :on-success="handleAvatarSuccessAudio"
              :before-upload="beforeAudioUpload"
              :on-progress="audioProgress"
            >
              <el-input
                style="width: 400px"
                v-model="itemFormEdit.Url"
                v-bind:disabled="true"
                type="textarea"
                clearable
              ></el-input>
            </el-upload>
            <el-progress
              :percentage="audioPlan"
              style="width: 300px"
              v-if="audioPlan"
            ></el-progress>
          </el-form-item>
          <el-form-item label="版本号" prop="Version">
            <el-input
              style="width: 400px"
              v-model="itemFormEdit.Version"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="OrderSort">
            <el-select
              v-model="itemFormEdit.OrderSort"
              clearable
              placeholder="请选择"
            >
              <el-option :key="1" :label="'安卓'" :value="1" />
              <el-option :key="2" :label="'IOS'" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="更新内容" prop="Version">
            <el-input
              style="width: 400px"
              type="textarea"
              :rows="4"
              v-model="itemFormEdit.Content"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="dialogToEdit = false">取消</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="editLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  ///主页API
  GetVersionList,
  GetVersionAdd,
  GetVersionEdit,
  GetVersionDel,
} from "../../api/api";
import Toolbar from "../../components/Toolbar";
import { mapState } from "vuex";

export default {
  components: { Toolbar },
  data() {
    return {
      //批量删除
      Name: "",

      //分页
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      //列
      users: [],
      //传参
      ///新增
      dialogToAdd: false,
      addLoading: false,
      itemForm: {
        OrderSort: "1",
        Name: "",
        Url: "",
        Version: "",
      },
      itemFormRusle: {
        OrderSort: [{ required: true, message: "选择类型", trugger: "red" }],
        Name: [{ required: true, message: "项目名称", trugger: "red" }],
        Url: [{ required: true, message: "文件地址", trugger: "red" }],
        Version: [{ required: true, message: "版本号", trugger: "red" }],
        Content: [
          { required: true, message: "请输入更新内容", trugger: "red" },
        ],
      },
      dialogToEdit: false,
      editLoading: false,
      itemFormEdit: {},
      audioPlan: 0,
    };
  },
  async created() {
    await this.__init();
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  mounted() {},
  methods: {
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.__init();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.__init();
    },
    handleDelect(item) {
      let that = this;
      this.$confirm("此操作将永久删除此版本, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await GetVersionDel({
            ids: [item.Id],
          });
          if (xhr.data.success) {
            that.$message({
              type: "success",
              message: "删除成功",
            });
            that.__init();
          } else {
            that.$message({
              type: "error",
              message: xhr.data.msg,
            });
          }
        })
        .catch(() => {});
    },
    addNewV() {
      this.itemForm.Name = "";
      this.itemForm.Url = "";
      this.itemForm.Version = "";
      this.dialogToAdd = true;
    },
    audioProgress(e) {
      this.audioPlan = Math.ceil((e.percent / e.total) * 100);
      if (this.audioPlan >= 100) {
        setTimeout(() => {
          this.audioPlan = 0;
        }, 200);
      }
    },
    handleAvatarSuccessAudio(res) {
      if (res.success) {
        this.itemForm.Url = res.url;
        this.itemFormEdit.Url = res.url;
        this.audioPlan = 100;
        setTimeout(() => {
          this.audioPlan = 0;
        }, 200);
      } else {
        this.$message.warning("上传失败");
      }
    },
    beforeAudioUpload(file) {
      // let typeArr = file.type.split("/");
      // if (typeArr[0] == "audio") {
      //   return true;
      // } else {
      //   this.$message.warning("请上传音频文件");
      //   return false;
      // }
    },

    //列表
    async __init() {
      let params = {
        Name: this.Name,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      await GetVersionList(params).then((res) => {
        if (res.data.success) {
          if (res.data.response && res.data.response.data) {
            this.users = res.data.response.data;
            this.total = res.data.response.dataCount;
          } else {
            this.users = [];
            this.total = 0;
          }
        } else {
          this.users = [];
        }
      });
    },

    //增加
    addSubmit() {
      this.$refs.itemForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          GetVersionAdd(this.itemForm).then((res) => {
            if (res.data.success) {
              this.addLoading = false;
              this.dialogToAdd = false;
              this.__init();
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            }
          });
        }
      });
    },
    ///编辑
    handleEdits(e) {
      this.itemFormEdit = e;
      this.dialogToEdit = true;
    },
    editSubmit() {
      //console.log(this.itemFormEdit);
      if (true) {
        this.addLoading = true;
        GetVersionEdit(this.itemFormEdit).then((res) => {
          if (res.data.success) {
            this.editLoading = false;
            this.dialogToEdit = false;
            this.__init();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          } else
            this.$message({
              type: "success",
              message: res.data.msg,
            });
        });
      }
    },

    ///清空模态框的数据
    Close() {
      this.itemFormEdit = {};
    },
  },
};
</script>
<style lang="less" scoped>
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
  border: 1px solid #c0c4cc;
}
</style>